import React from 'react';
import { useTranslation } from 'react-i18next';

const STYLES = {
  WRAPPER: 'w-[464px] bg-bw00 h-fit relative flex flex-col h-fit rounded-[8px] border-[1px] border-bw03',
  BOX_HEAD_ROW: 'bg-bw00 h-[98px] flex flex-col items-center justify-center rounded-t-[8px] border-b-[1px] border-bw03',
  BOX_ROW: 'w-full flex justify-between bg-bw00 border-b-[1px] border-bw03 px-[16px] py-[12px]',
  ROW_HEAD_VALUE: 'text-[26px] text-action03 font-metricRMedium leading-9',
  ROW_TITLE: 'text-md text-bw07 font-metricR leading-6 items-center flex',
  ROW_VALUE: 'w-full text-md text-bw08 font-metricR leading-6 tracking-[0.04em]',
  ROW_VALUE_WRAPPER: 'w-[240px] h-full flex flex-col text-right justify-center',
  FOOTER_ROW:
    'h-[40px] flex justify-center items-center bg-bw01 rounded-b-[8px] text-bw07 font-metricR leading-5 text-sm',
};

export interface ISuccessBoxRow {
  title: string;
  value: string;
  value2?: string;
}

interface ITransferSuccessBoxProps {
  rowsData: ISuccessBoxRow[];
  processTime: string;
}

const TransferSuccessBox = ({ rowsData, processTime }: ITransferSuccessBoxProps) => {
  const { t } = useTranslation();
  const headRowData = rowsData && rowsData[0];
  const bodyRowData = rowsData && rowsData.slice(1);
  const renderHeadRow = (rowData: ISuccessBoxRow) => {
    if (!rowData) return false;
    return (
      <div className={STYLES.BOX_HEAD_ROW} data-testid='TransferSuccessPage-HeadRow'>
        <div className={STYLES.ROW_TITLE} data-testid='TransferSuccessPage-HeadRowTitle'>
          {rowData.title}
        </div>
        <div className={STYLES.ROW_HEAD_VALUE} data-testid='TransferSuccessPage-HeadRowValue'>
          {rowData.value}
        </div>
      </div>
    );
  };
  const renderBodyRows = (bodyRowsData: ISuccessBoxRow[]) =>
    bodyRowsData?.map((row) => (
      <div className={STYLES.BOX_ROW} data-testid='TransferSuccessPage-Row' key={`key_${row.title}`}>
        <div className={STYLES.ROW_TITLE} data-testid='TransferSuccessPage-RowTitle'>
          {row.title}
        </div>
        <div className={STYLES.ROW_VALUE_WRAPPER}>
          <div className={STYLES.ROW_VALUE} data-testid='TransferSuccessPage-RowValue'>
            {row.value}
          </div>
          {row.value2 && (
            <div className={STYLES.ROW_VALUE} data-testid='TransferSuccessPage-RowValue2'>
              {row.value2}
            </div>
          )}
        </div>
      </div>
    ));
  return (
    <div className={STYLES.WRAPPER}>
      {renderHeadRow(headRowData)}
      {renderBodyRows(bodyRowData)}
      <div className={STYLES.FOOTER_ROW}>{`${t('SUCCESS_PAGE.PROCESS_TITLE')} ${processTime}`}</div>
    </div>
  );
};

export default TransferSuccessBox;
